
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lyziarske-stredisko",
      function () {
        return require("private-next-pages/lyziarske-stredisko.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lyziarske-stredisko"])
      });
    }
  